import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow js-main-content" }
const _hoisted_2 = { class: "_mb-2" }
const _hoisted_3 = { class: "gfu-grid gfu-grid--gutter" }
const _hoisted_4 = {
  key: 0,
  class: "_mt-2"
}
const _hoisted_5 = { class: "gfu-grid gfu-grid--gutter _mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "gfu-grid__cell gfu-1of1"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_account_navigation = _resolveComponent("account-navigation")
  const _component_base_title = _resolveComponent("base-title")
  const _component_system_notification_management_settings = _resolveComponent("system-notification-management-settings")
  const _component_creator_notification_management_settings = _resolveComponent("creator-notification-management-settings")
  const _component_project_notification_management_settings = _resolveComponent("project-notification-management-settings")
  const _component_search_field = _resolveComponent("search-field")
  const _component_subscribed_creator_management_settings = _resolveComponent("subscribed-creator-management-settings")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, { "is-processing": _ctx.isProcessing }, {
    default: _withCtx(() => [
      _createVNode(_component_account_navigation, { "page-identity": _ctx.pageID }, null, 8 /* PROPS */, ["page-identity"]),
      _createElementVNode("main", _hoisted_1, [
        _createVNode(_component_base_title, {
          as: "h1",
          class: "_mt-6",
          "data-qa": "page-title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.SubscriptionManagement.PageHeader), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.SubscriptionManagement.PageIntroParagraph), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, [
          ($options.showSystemNotificationFields)
            ? (_openBlock(), _createBlock(_component_system_notification_management_settings, _mergeProps({ key: 0 }, $options.systemNotificationProps, { onSystemNotificationPreferenceChange: $options.updateUserSubscription }), null, 16 /* FULL_PROPS */, ["onSystemNotificationPreferenceChange"]))
            : _createCommentVNode("v-if", true),
          ($options.showCreatorNotificationFields)
            ? (_openBlock(), _createBlock(_component_creator_notification_management_settings, {
                key: 1,
                "creator-notification-settings": _ctx.creatorNotificationSettings,
                "creator-subscriptions": $options.creatorDigestSubscriptions,
                onNotificationPreferenceChange: $options.updateUserSubscription
              }, null, 8 /* PROPS */, ["creator-notification-settings", "creator-subscriptions", "onNotificationPreferenceChange"]))
            : _createCommentVNode("v-if", true),
          ($options.showProjectNotificationFields)
            ? (_openBlock(), _createBlock(_component_project_notification_management_settings, _mergeProps({ key: 2 }, _ctx.projectNotifications, { onProjectNotificationPreferenceChange: $options.updateUserSubscription }), null, 16 /* FULL_PROPS */, ["onProjectNotificationPreferenceChange"]))
            : _createCommentVNode("v-if", true)
        ]),
        ($options.showProjectNotificationFields)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_search_field, {
                "model-value": _ctx.searchingPhase,
                "display-name": _ctx.Resources.SubscriptionManagement.ProjectSearchFieldLabel,
                placeholder: _ctx.Resources.SubscriptionManagement.ProjectSearchFieldPlaceholder,
                "label-class": "_mb-h",
                "onUpdate:modelValue": $options.onInput,
                "data-qa": "search-field"
              }, null, 8 /* PROPS */, ["model-value", "display-name", "placeholder", "onUpdate:modelValue"]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.subscribedCreatorsToShow, (creator) => {
                  return (_openBlock(), _createBlock(_component_subscribed_creator_management_settings, _mergeProps({ ref_for: true }, creator, {
                    key: creator.creatorID,
                    onProjectNotificationPreferenceChange: $options.updateUserSubscription
                  }), null, 16 /* FULL_PROPS */, ["onProjectNotificationPreferenceChange"]))
                }), 128 /* KEYED_FRAGMENT */)),
                (!$options.hasFilteredSubscribedCreators)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_box, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_empty_state, {
                            title: _ctx.Resources.SubscriptionManagement.ProjectSearchEmptyStateHeader,
                            "data-qa": "subscription-management:EmptyState"
                          }, null, 8 /* PROPS */, ["title"])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              ($options.canLoadMoreRows)
                ? (_openBlock(), _createBlock(_component_load_more_trigger, {
                    key: 0,
                    onLoadMore: $options.loadMoreRows
                  }, null, 8 /* PROPS */, ["onLoadMore"]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-processing"]))
}